const $inject = ['$rootScope', '$state', 'authService', 'sctUserPermissionsService', 'AUTH_EVENTS', 'SCT_CONFIG'];

const sctNavCtrl = function ($rootScope, $state, authService, sctUserPermissionsService, AUTH_EVENTS, SCT_CONFIG) {
  let vm = this;
  vm.state = $state;
  vm.openUserNav = false;
  vm.supportUrl = SCT_CONFIG.supportUrl;
  vm.userPermission = sctUserPermissionsService.permissions;
  vm.checkNewBooking = checkNewBooking;

  vm.navHighlighterConfig = {
    itemsName: 'li',
    itemActiveClassName: 'active',
    indicatorClassName: 'sctSiteNavBar_indicator'
  };

  vm.clickOutside = clickOutside;
  vm.logout = logout;
  vm.goto = goto;

  function logout() {
    authService.logout().then(function () {
      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
    });
  }

  function clickOutside() {
    vm.openUserNav = false;
  }

  function goto(stateName) {
    if ($state.current.name !== stateName) {
      $state.go(stateName);
    }
  }

  function checkNewBooking() {
    return $state.includes('app.home.search') || $state.includes('app.booking') || $state.includes('app.itinerary')
      || $state.includes('app.bookingConfirmation')
  }
};

sctNavCtrl.$inject = $inject;

export default sctNavCtrl;




// WEBPACK FOOTER //
// ./src/components/sct/sctNav/sctNavCtrl.js